import type { FC } from 'react'
import React from 'react'
import { PaperIcon } from '@frontend/pole-ui/lib/components/Icon/svg/PaperIcon'
import { InjectHtml, TextWithIcon } from '@/components/ui'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { LandingBlockContainer } from '..'
import type { IPreferentialLeasingProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const PreferentialLeasing: FC<IPreferentialLeasingProps> = ({ blockId }) => {
  const isMobile = useDeviceType()

  const optionTagName = isMobile ? 'h5' : 'h4'

  return (
    <LandingBlockContainer
      className="preferential-leasing-block "
      titleClassName="space-holder16-sm"
      title={messages.title}
      blockId={blockId}
      withoutPageWrapper
    >
      <TextWithIcon
        className="preferential-leasing-block__note space-holder24-sm space-holder40-from-sm text_small-sm"
        iconProps={{ component: <PaperIcon /> }}
        text={messages.blockNote}
      />
      <div className="preferential-leasing wide-mobile-block">
        <div>
          <InjectHtml className="space-holder16" TagName="p" html={messages.text} />
          <p className="preferential-leasing__note color_pale-black space-holder24-sm text_small-from-sm">{messages.note}</p>
        </div>
        <div className="preferential-leasing-options">
          <div className="preferential-leasing-options__item space-holder-right4">
            <InjectHtml TagName={optionTagName} html={messages.options.uptoTenPercents.text} />
            <InjectHtml className="color_pale-black space-holder-top4-sm text_small" html={messages.options.uptoTenPercents.caption} />
          </div>
          <div className="preferential-leasing-options__item preferential-leasing-options__item_right">
            <InjectHtml TagName={optionTagName} html={messages.options.uptoFiveHundred.text} />
            <InjectHtml className="color_pale-black space-holder-top4-sm text_small" html={messages.options.uptoFiveHundred.caption} />
          </div>
          <InjectHtml
            TagName="span"
            className="preferential-leasing-options__choose-circle color_white text_small"
            textId={messages.options.chooseCircle}
          />
        </div>
      </div>
    </LandingBlockContainer>
  )
}

export default PreferentialLeasing
